/**
 * useStoredFlag (KAN-904)
 *
 * Булев флаг интерфейса (показать/скрыть блок), запомненный в localStorage
 * значением '1' / '0'. Недоступное хранилище (приватный режим, запрет сайта)
 * не ломает флаг: действует значение по умолчанию, смена живёт до перезагрузки.
 */
import { useCallback, useState } from 'react';

export function readStoredFlag(key: string, fallback: boolean): boolean {
  try {
    const raw = localStorage.getItem(key);
    if (raw === '1') return true;
    if (raw === '0') return false;
    return fallback;
  } catch {
    return fallback;
  }
}

export function writeStoredFlag(key: string, value: boolean): void {
  try {
    localStorage.setItem(key, value ? '1' : '0');
  } catch {
    // Хранилище недоступно: флаг действует до перезагрузки страницы.
  }
}

/** Возвращает [значение, переключить]. */
export function useStoredFlag(key: string, fallback: boolean): [boolean, () => void] {
  const [value, setValue] = useState(() => readStoredFlag(key, fallback));

  const toggle = useCallback(() => {
    const next = !value;
    setValue(next);
    writeStoredFlag(key, next);
  }, [key, value]);

  return [value, toggle];
}
